export default __webpack_public_path__ + "images/9B.1ad9919.png";